import vue from 'vue'
import EditMotto from './EditMotto'
import store from '@/store/index'
const EditMottoCreater = vue.extend(EditMotto)
let editMottoInstance

export default {
  open (motto) {
    return new Promise((resolve, reject) => {
      if (editMottoInstance) {
        editMottoInstance = null
      }
      let currentdiv = document.createElement('div')
      currentdiv.id = 'editMottoInstance'
      document.body.appendChild(currentdiv)
      editMottoInstance = new EditMottoCreater({
        data () {
          return {
            visible: true,
            motto: motto,
            resolve: resolve,
            reject: reject
          }
        },
        store,
      }).$mount('#editMottoInstance')
    })
  },
  close () {
    if (!editMottoInstance) return 
    editMottoInstance.visible = false
  }
}